import { baseAPIUrl, httpPostHandleResponse, baseWebUrl, sweetAlert, AlertType, AlertTitle } from "../../utils/common";
import { Loader } from "../../services/loaderService";
import http, { GetToken } from "../../services/httpService";
import { AxiosResponse } from "axios";
import { PartialJobSearch } from "../Jobs/_PartialJobSearch";


class Constants {
    readonly controller: string = baseAPIUrl() ? `${baseAPIUrl()}/JobPosting` : '/JobPosting';
    readonly LoginController: string = baseWebUrl() ? `${baseWebUrl()}/Account` : '/Account';
    readonly controllerCandidate: string = baseAPIUrl() ? `${baseAPIUrl()}/Candidate` : '/Candidate';

    readonly btnjobmodal: string = "#btnjobmodal";
    readonly btnModalCross: string = "#btnModalCross";
    readonly btnJobApply: string = "#btnJobApply";
    readonly btnJobSave: string = "#btnJobSave";

}

class FindJob {

    loader: Loader = new Loader();
    constants: Constants = new Constants();
    PartialJobSearch: PartialJobSearch;
    $btnjobmodal: JQuery<HTMLElement>;
    $btnModalCross: JQuery<HTMLElement>;
    $btnJobApply: JQuery<HTMLElement>;
    $btnJobSave: JQuery<HTMLElement>;

    constructor() {

        this.Init();
    }

    private Init = async () => {

        this.PartialJobSearch = new PartialJobSearch();
        this.loader.showLoader();
        this.BindEvent();
        this.loader.hideLoader()
    }

    private BindEvent = async () => {
        this.$btnModalCross = $(this.constants.btnModalCross);
        this.$btnjobmodal = $(this.constants.btnjobmodal);
        this.$btnJobApply = $(this.constants.btnJobApply);
        this.$btnJobApply.on('click', this.assignJobs);
        this.$btnModalCross.on('click', this.jobmodalhide);
        this.$btnjobmodal.on('click', this.jobmodalhide);

        this.$btnJobSave = $(this.constants.btnJobSave);
        this.$btnJobSave.on('click', this.saveJob);

    }

    private assignJobs = async () => {

        GetToken();

        const id = $('#hfJobId').val();
        let data: any
            , response: AxiosResponse<any>;

        response = await http.get(this.constants.controllerCandidate + "/CheckCandidateBasicInfoExists");
        data = httpPostHandleResponse(response);

        if (data) {
            let data2: any
                , response2: AxiosResponse<any>;
            response2 = await http.post(this.constants.controller + "/CandidateJobs/" + id);
            data2 = httpPostHandleResponse(response2);
            if (data2) {
                sweetAlert(AlertType.Success, AlertTitle.Success, "Successfully Applied For This Job");
            }
        }

        //window.location.href = (this.constants.LoginController + "/Login?JobId=" + $('#hfJobId').val() );
    }

    private saveJob = async () => {

        GetToken();
        const id = $('#hfJobId').val();
        let data: any
            , response: AxiosResponse<any>;
        response = await http.post(this.constants.controller + "/SavedCandidateJobs/" + id);
        data = httpPostHandleResponse(response);
        if (data) {
            sweetAlert(AlertType.Success, AlertTitle.Success, "Job Saved Successfully ");
        }

        //window.location.href = (this.constants.LoginController + "/Login?JobId=" + $('#hfJobId').val());
    }

    private jobmodalhide = async () => {
        console.log(3);
        const modal: any = $('#viewJobDetail');
        modal.modal('hide');
    }
}

$(() => new FindJob());